// auth token, logged
export const LOGOUT = "LOGOUT";
export const LOGIN_TOKEN = "LOGIN_TOKEN";
export const LOGIN_USER = "LOGIN_USER";
export const REFRESHING_TOKEN = "REFRESHING_TOKEN";
export const TOKEN_REFRESHED = "TOKEN_REFRESHED";
export const SET_AUTH_LOADING = "SET_AUTH_LOADING";
export const INVALID_TOKEN = "INVALID_TOKEN";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_COMPANY_DATA = "SET_COMPANY_DATA";
export const SET_JOB_DATA = "SET_JOB_DATA";
export const SET_JOB_DETAIL_DATA = "SET_JOB_DETAIL_DATA";
export const SET_ASSESSMENT_DATA = "SET_ASSESSMENT_DATA";
export const SET_CANDIDATES_DATA = "SET_CANDIDATES_DATA";
export const SET_CANDIDATES_ASSESSMENT_DATA = "SET_CANDIDATES_ASSESSMENT_DATA";
export const SET_SEARCH_DATA = "SET_SEARCH_DATA";
export const RESET_SEARCH_DATA = "RESET_SEARCH_DATA";
//messages
export const SET_UNSEEN_MESSAGE_COUNT = "SET_UNSEEN_MESSAGE_COUNT";
export const RESET_UNSEEN_MESSAGE_COUNT = "RESET_UNSEEN_MESSAGE_COUNT";
export const SET_JOB_MEMBERS_PROFILE = "SET_JOB_MEMBERS_PROFILE";
export const SET_CHAT_RECEIVER_DETAILS = "SET_CHAT_RECEIVER_DETAILS";

export const SET_CLIENT_SECRET = "SET_CLIENT_SECRET";
export const SET_CONNECTED_ACCOUNT_DATA = "SET_CONNECTED_ACCOUNT_DATA";

// Action types for fetching banks
export const FETCH_BANKS_REQUEST = "FETCH_BANKS_REQUEST";
export const FETCH_BANKS_SUCCESS = "FETCH_BANKS_SUCCESS";
export const FETCH_BANKS_FAILURE = "FETCH_BANKS_FAILURE";
export const FETCH_BANK_BY_ID_SUCCESS = "FETCH_BANK_BY_ID_SUCCESS";
export const FETCH_BANK_BY_ID_FAILURE = "FETCH_BANK_BY_ID_FAILURE";

// Action types for deleting a bank
export const DELETE_BANK_REQUEST = "DELETE_BANK_REQUEST";
export const DELETE_BANK_SUCCESS = "DELETE_BANK_SUCCESS";
export const DELETE_BANK_FAILURE = "DELETE_BANK_FAILURE";

// Action types for fetching connected accounts
export const FETCH_CONNECTED_ACCOUNT_DETAILS_REQUEST =
  "FETCH_CONNECTED_ACCOUNT_DETAILS_REQUEST";
export const FETCH_CONNECTED_ACCOUNT_DETAILS_SUCCESS =
  "FETCH_CONNECTED_ACCOUNT_DETAILS_SUCCESS";
export const FETCH_CONNECTED_ACCOUNT_DETAILS_FAILURE =
  "FETCH_CONNECTED_ACCOUNT_DETAILS_FAILURE";

// Paymeny methods
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";

// set referral details for payment by recruiter
export const SET_REFERRAL_DETAILS = "SET_REFERRAL_DETAILS";

// Payment histories (transaction for referral)
export const FETCH_PAYMENT_HISTORIES_REQUEST =
  "FETCH_PAYMENT_HISTORIES_REQUEST";
export const FETCH_PAYMENT_HISTORIES_SUCCESS =
  "FETCH_PAYMENT_HISTORIES_SUCCESS";
export const FETCH_PAYMENT_HISTORIES_FAILURE =
  "FETCH_PAYMENT_HISTORIES_FAILURE";

// Payment history details (transaction for referral)
export const FETCH_PAYMENT_HISTORY_DETAILS_REQUEST =
  "FETCH_PAYMENT_HISTORY_DETAILS_REQUEST";
export const FETCH_PAYMENT_HISTORY_DETAILS_SUCCESS =
  "FETCH_PAYMENT_HISTORY_DETAILS_SUCCESS";
export const FETCH_PAYMENT_HISTORY_DETAILS_FAILURE =
  "FETCH_PAYMENT_HISTORY_DETAILS_FAILURE";

export const FETCH_RECEIPT_USER_DETAILS_REQUEST =
  "FETCH_RECEIPT_USER_DETAILS_REQUEST";
export const FETCH_RECEIPT_USER_DETAILS_SUCCESS =
  "FETCH_RECEIPT_USER_DETAILS_SUCCESS";
export const FETCH_RECEIPT_USER_DETAILS_FAILURE =
  "FETCH_RECEIPT_USER_DETAILS_FAILURE";

/**
 * Subscription
 */
export const FETCH_SUBSCRIPTION_PLANS_REQUEST =
  "FETCH_SUBSCRIPTION_PLNS_REQUEST";
export const FETCH_SUBSCRIPTION_PLANS_SUCCESS =
  "FETCH_SUBSCRIPTION_PLANS_SUCCESS";
export const FETCH_SUBSCRIPTION_PLANS_FAILURE =
  "FETCH_SUBSCRIPTION_PLANS_FAILURE";
export const FETCH_ACTIVE_SUBSCRIPTION_PLAN_REQUEST =
  "FETCH_ACTIVE_SUBSCRIPTION_PLAN_REQUEST";
export const FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS =
  "FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS";
export const FETCH_ACTIVE_SUBSCRIPTION_PLAN_FAILURE =
  "FETCH_ACTIVE_SUBSCRIPTION_PLAN_FAILURE";
export const SET_ACTIVE_PLAN = "SET_ACTIVE_PLAN";
export const SET_SELECTED_PLAN_DETAILS = "SET_SELECTED_PLAN_DETAILS";

export const CANCEL_SUBSCRIPTION_REQUEST = "CANCEL_SUBSCRIPTION_REQUEST";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_FAILURE = "CANCEL_SUBSCRIPTION_FAILURE";

export const UNDO_CANCEL_SUBSCRIPTION_REQUEST =
  "UNDO_CANCEL_SUBSCRIPTION_REQUEST";
export const UNDO_CANCEL_SUBSCRIPTION_SUCCESS =
  "UNDO_CANCEL_SUBSCRIPTION_SUCCESS";
export const UNDO_CANCEL_SUBSCRIPTION_FAILURE =
  "UNDO_CANCEL_SUBSCRIPTION_FAILURE";

export const FETCH_NOTIFICATION_COUNTS = "FETCH_NOTIFICATION_COUNTS";
export const UPDATE_NOTIFICATION_COUNTS = "UPDATE_NOTIFICATION_COUNTS";

export const UPDATE_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";

